/* eslint-disable react/destructuring-assignment */

import { useIntl } from 'react-intl';
import { Content } from '../Content';
import { PromotionComponentLayout2Messages } from './messages';
import { usePriceFormater } from '../../../../hooks/usePriceFormater';
import { OutlinedCard } from '../../../OutlinedCard';
import {
  ContentWrapper,
  ContentWrapperCallToAction,
  ContentWrapperContent,
} from '../ContentWrapper';

const offsetCircle = '0.938rem';

export type Layout2Props = React.HTMLAttributes<HTMLDivElement> & {
  /**
   * the single installment value from the calculation result as float (e.g. 13.37)
   */
  singleInstallment: number;
  /**
   * the currency string from the calculation result
   */
  currency: string;
  /**
   * the number of installments from the calculation result
   */
  numberOfInstallments: number;
  /**
   * open dialog handler
   */
  openInstallmentCalulatorHandler: () => void;
};

/**
 * Promotion component Layout 2
 *
 * component to promote the installment calculator in layout version 2
 *
 * */
export const Layout2 = ({
  singleInstallment,
  currency,
  numberOfInstallments,
  openInstallmentCalulatorHandler,
  ...props
}: Layout2Props) => {
  const { formatMessage } = useIntl();
  const formatPrice = usePriceFormater('INSTALLMENTCALCULATOR');

  const handleWrapperAction = () => {
    openInstallmentCalulatorHandler();
  };

  return (
    <div
      className="cursor-default"
      style={{ marginTop: offsetCircle }}
      onClick={handleWrapperAction}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleWrapperAction();
        }
      }}
      aria-haspopup="dialog"
      aria-label={formatMessage(PromotionComponentLayout2Messages.CtA)}
      role="button"
      tabIndex={0}
      {...props}
    >
      <OutlinedCard className="relative p-0">
        <div
          className="absolute left-1/2"
          style={{
            top: `-${offsetCircle}`,
            transform: 'translate(-50%, 0)',
          }}
        >
          {/* a white line to have space between cirle and border */}
          <div
            className="bg-color-background-base absolute left-1/2"
            style={{
              top: offsetCircle,
              transform: 'translate(-50%, -2px)',
              width: '3.75rem',
              height: '5px',
            }}
          />
          <div
            className="bg-color-primary relative box-border rounded-full"
            style={{
              width: '2.875rem',
              height: '2.875rem',
              padding: '0.438rem 0.313rem 0.438rem 0.563rem',
            }}
          >
            <span className="icon-emp-installmentplan text-color-text-light h-4 w-4" />
          </div>
        </div>
        <ContentWrapper>
          <ContentWrapperContent>
            <Content
              smallText={formatMessage(PromotionComponentLayout2Messages.From)}
              bigText={formatPrice(singleInstallment, currency)}
            />
            <Content
              smallText={formatMessage(PromotionComponentLayout2Messages.InstallmentsPrefix)}
              bigText={formatMessage(PromotionComponentLayout2Messages.Installments, {
                installments: numberOfInstallments,
              })}
            />
          </ContentWrapperContent>
          <ContentWrapperCallToAction>
            {formatMessage(PromotionComponentLayout2Messages.CtA)}
          </ContentWrapperCallToAction>
        </ContentWrapper>
      </OutlinedCard>
    </div>
  );
};
